import * as Yup from 'yup';

import { MAX_FILE_SIZE_5MB, SIRE_REVIEW_INVOICE_TYPE } from '@/common/constants';

export const invoiceSireReviewPaymentSchema = (type: string) => {
    return Yup.object({
      paymentDate: Yup.date().required("Payment date is required"),
      amountIDR:
        type === SIRE_REVIEW_INVOICE_TYPE.INSPECTOR
          ? Yup.string()
              .required("IDR amount is required")
              .matches(
                /^IDR[1-9][\d.,]*/,
                "IDR amount cannot be zero or negative"
              )
          : Yup.string().nullable(),
      paymentFile: Yup.mixed()
        .test("fileSize", "File size is too large", (value: any) => {
          if (value.size > MAX_FILE_SIZE_5MB) {
            return false;
          }

          return true;
        })
        .required("Payment file is required"),
    });
}
